/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { createRoot } from "react-dom/client";

import Galax from 'galax';
import Astro from 'astro';
import Solis from 'solis';

import 'global/auth.js';
import 'global/favicon.js';
import 'global/cookies.js';
import 'global/analytics.js';

import '@radix-ui/themes/styles.css';

import 'index.scss';


createRoot(document.getElementById('app')).render(<Solis />);
